// extracted by mini-css-extract-plugin
export default {"hide_button":"questionnaire-body_hide_button__vMnpL"};